import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X, Send } from "lucide-react";

const WA_NUMBER = "447502326927";

export default function WhatsAppFab() {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");

  const send = () => {
    const text = encodeURIComponent(msg || "Hi Harry, I'd like to book a consultation.");
    window.open(`https://wa.me/${WA_NUMBER}?text=${text}`, "_blank", "noopener");
    setOpen(false);
  };

  return (
    <div className="fixed bottom-6 right-6 z-[60] flex flex-col items-end gap-4" data-testid="whatsapp-widget">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 16, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.95 }}
            transition={{ duration: 0.25, ease: "easeOut" }}
            className="w-72 md:w-80 border border-white/10 bg-zinc-950 shadow-2xl"
            data-testid="whatsapp-popup"
          >
            <div className="flex items-center justify-between bg-gold px-4 py-3">
              <p className="font-display font-semibold uppercase tracking-[0.15em] text-black text-sm">Chat With A Coach</p>
              <button onClick={() => setOpen(false)} data-testid="whatsapp-close-btn" aria-label="Close chat" className="text-black/70 hover:text-black transition-colors">
                <X className="w-4 h-4" />
              </button>
            </div>
            <div className="p-4 space-y-3">
              <p className="text-zinc-400 text-sm">Replies within the hour, 6:00–20:00.</p>
              <textarea
                value={msg}
                onChange={(e) => setMsg(e.target.value)}
                data-testid="whatsapp-message-input"
                placeholder="Hi! I want to get faster for next season..."
                rows={3}
                className="w-full bg-secondary/60 border border-white/10 text-white text-sm p-3 placeholder:text-zinc-500 focus:outline-none focus:ring-1 focus:ring-gold resize-none"
              />
              <button
                onClick={send}
                data-testid="whatsapp-send-btn"
                className="w-full inline-flex items-center justify-center gap-2 bg-gold text-black font-display font-semibold uppercase tracking-[0.15em] text-sm px-4 py-3 hover:bg-gold-bright transition-colors duration-300"
              >
                Open WhatsApp <Send className="w-4 h-4" />
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="whatsapp-fab"
        aria-label="Open WhatsApp chat"
        className="pulse-ring relative w-14 h-14 md:w-16 md:h-16 rounded-full bg-gold text-black flex items-center justify-center hover:bg-gold-bright transition-colors duration-300 shadow-xl"
      >
        {open ? <X className="w-6 h-6" /> : <MessageCircle className="w-6 h-6 md:w-7 md:h-7" />}
      </button>
    </div>
  );
}
